import { createSelector, createSlice } from "@reduxjs/toolkit";

interface UserState {
  isVendorAdmin: null | boolean;
}

const initialState: UserState = {
  isVendorAdmin: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  selectors: {
    GET_USER_STATE: createSelector([(state) => state], (state) => {
      return {
        user: {
          isVendorAdmin: state?.isVendorAdmin,
        },
      };
    }),
  },
  reducers: {
    SET_USER_VENDOR_ADMIN_ROLE: (state, action) => {
      return {
        ...state,
        isVendorAdmin: action.payload,
      };
    },
  },
});

export const { SET_USER_VENDOR_ADMIN_ROLE } = userSlice.actions;
export const { GET_USER_STATE } = userSlice.selectors;
export default userSlice.reducer;
